<template>
  <div class="xy-horizontal-layout" :style="layoutStyle">
    <xyComponent v-for="element in elements" :element="element" :key="element.uuid" :language="props.language" :list-index="props.listIndex" :list-item-data="props.listItemData" />
  </div>
</template>

<script setup>
import { computed, ref, onBeforeMount } from 'vue'
import { info, defaultProps } from './config'
import xyComponent from '@/packages/components/xy-component.vue'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const elements = ref([])

const setChilderen = (nodes) => {
  if (!nodes || !nodes.length) {
    elements.value = []
    return
  }
  nodes.forEach((node) => {
    node.style = {
      ...node.style,
      flex: '0 0 auto'
    }
  })
  elements.value = nodes
}

const layoutStyle = computed(() => {
  return {
    overflowX: props.scroll ? 'scroll' : 'hidden',
    justifyContent: props.justifyContent ?? 'normal'
  }
})

onBeforeMount(() => {
  setChilderen(props.element.nodes)
})
</script>

<style lang="scss" scoped>
.xy-horizontal-layout {
  display: flex;
  flex-wrap: nowrap;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.xy-vertical-layout::-webkit-scrollbar {
  display: none;
}
</style>
